document.addEventListener('DOMContentLoaded', function () {
  const iconCart = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>`;
  const iconCheck = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>`;

  function initQtySelectors() {
    document.querySelectorAll('.product-item__qty-selector').forEach(function (selector) {
      if (selector.dataset.qtyInit) return;
      selector.dataset.qtyInit = '1';

      const step     = parseInt(selector.dataset.step) || 1;
      const price    = parseInt(selector.dataset.price) || 0;
      const input    = selector.querySelector('.product-item__qty-input');
      const row      = selector.closest('.product-item__qty-row');
      const total    = row
                         ? row.parentElement.querySelector('.product-item__qty-total-value')
                         : selector.querySelector('.product-item__qty-total-value');
      const btnMinus = selector.querySelector('.product-item__qty-btn--minus');
      const btnPlus  = selector.querySelector('.product-item__qty-btn--plus');

      function updateTotal(qty) {
        if (total) {
          total.textContent = (qty * price / 100).toLocaleString('fr-FR', {
            style: 'currency',
            currency: 'EUR'
          });
        }
      }

      btnPlus.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const next = parseInt(input.value) + step;
        input.value = next;
        updateTotal(next);
      });

      btnMinus.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const current = parseInt(input.value);
        if (current - step >= step) {
          input.value = current - step;
          updateTotal(current - step);
        }
      });
    });

    document.querySelectorAll('.js-qty-add-to-cart').forEach(function (btn) {
      if (btn.dataset.addInit) return;
      btn.dataset.addInit = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const card      = btn.closest('[data-js-product-item]');
        const input     = card ? card.querySelector('.product-item__qty-input') : null;
        const qty       = input ? parseInt(input.value) : 1;
        const variantId = btn.dataset.variantId;

        btn.classList.add('loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        })
        .then(res => res.json())
        .then(() => {
          btn.classList.remove('loading');
          return fetch('/cart.js');
        })
        .then(res => res.json())
        .then(cart => {
          document.querySelectorAll('[data-header-cart-count]').forEach(el => {
            el.textContent = cart.item_count;
          });
          btn.classList.remove('cart-count-pulse');
          void btn.offsetWidth;
          btn.classList.add('cart-count-pulse');
          btn.innerHTML = iconCheck;
          setTimeout(() => {
            btn.innerHTML = iconCart;
          }, 1500);
        })
        .catch(() => {
          btn.classList.remove('loading');
        });
      });
    });
  }

  initQtySelectors();

  const observer = new MutationObserver(initQtySelectors);
  observer.observe(document.body, { childList: true, subtree: true });
});